import ContactCardPage from './ContactCardPage';

export default ContactCardPage;


// WEBPACK FOOTER //
// ./src/components/pages/ContactCardPage/index.js